<template>
  <button class="btn_l" :type="type" @click="click">
    <slot />
  </button>
</template>
<script>
export default {
  props: {
    type: {
      default() {
        return "default";
      },
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
.btn_l + .btn_l {
  margin-left: 15px;
}
.btn_l {
  user-select: none;
  display: inline-block;
  padding: 0 16px;
  font-size: 14px;
  transition: all 0.3s;
  border-radius: 1px 1px 1px 1px;
  height: 34px;
  line-height: 34px;
  min-width: 90px;
  cursor: pointer;
  &[type="default"] {
    border: 1px solid #e4e8eb;
    background: #fff;
    color: #404961;
    &:hover {
      border: 1px solid #4479eb;
      color: #4479eb;
    }
    &:active {
      border: 1px solid #326be4;
      color: #326be4;
    }
  }
  &[type="blue"] {
    background: #386fed;
    border: 1px solid #386fed;
    color: #fff;
    &:hover {
      background: #5486f9;
      border: 1px solid #5486f9;
    }
    &:active {
      background: #275fe1;
      border: 1px solid #275fe1;
    }
  }
  &[round] {
    min-width: 76px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px 12px 12px 12px;
    background: #eaf0fe;
    color: #4479eb;
    border: none;
    &:hover {
      color: #6393fa;
      background: #eaf0fe;
      border: none;
    }
    &:active {
      color: #326be4;
      background: #eaf0fe;
      border: none;
    }
  }
  &[disabled] {
    background: #f4f6f8;
    color: #b8c0c9 !important;
    border: 1px solid #d3d9e2;
    cursor: no-drop;
    &:hover,
    &:active {
      background: #f4f6f8;
      color: #b8c0c9;
      border: 1px solid #d3d9e2;
    }
  }
  &[type="text"] {
    padding: 0;
    color: #4479eb;
    border: none;
    background: transparent;
    min-width: 0;
    &:hover {
      color: #6393fa;
      background: transparent;
      border: none;
    }
    &:active {
      color: #326be4;
      background: transparent;
      border: none;
    }
  }
}
</style>